import React from 'react';
import { companyInfo } from '../data/mock';
import { Target, Briefcase, TrendingUp, DollarSign, Settings, Users, FileText, Building, ClipboardList, PieChart, BarChart, Calculator, SearchCheck, LineChart, Handshake } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const iconMap = {
  target: Target,
  briefcase: Briefcase,
  trendingUp: TrendingUp,
  dollarSign: DollarSign,
  settings: Settings,
  users: Users,
  fileText: FileText,
  building: Building,
  clipboardList: ClipboardList,
  pieChart: PieChart,
  barChart: BarChart,
  calculator: Calculator,
  searchCheck: SearchCheck,
  lineChart: LineChart,
  handshake: Handshake
};

// Gulf professional images for service cards
const serviceImages = [
  'https://images.unsplash.com/photo-1681505526188-b05e68c77582', // Business handshake
  'https://images.unsplash.com/photo-1720722023443-1e50fb98f2e6', // Gulf professionals
  'https://images.pexels.com/photos/8939110/pexels-photo-8939110.jpeg', // Diverse consultation
  'https://images.pexels.com/photos/9750629/pexels-photo-9750629.jpeg', // Group meeting
  'https://images.unsplash.com/photo-1719561940608-ee6e2ef33d23', // Traditional Gulf attire
  'https://images.pexels.com/photos/10616184/pexels-photo-10616184.jpeg' // Qatar professional
];

// Service-specific images representing each service
const serviceSpecificImages = {
  1: 'https://images.pexels.com/photos/8867261/pexels-photo-8867261.jpeg', // Management Consultancy - meeting
  2: 'https://images.unsplash.com/photo-1521791136064-7986c2920216', // Commercial Services - handshake
  3: 'https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20%281%20of%201%29-5.jpg', // Business Strategy - meeting
  4: 'https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d', // Financial Advisory - reports
  5: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40', // Operations Management - laptop
  6: 'https://images.unsplash.com/photo-1521791055366-0d553872125f', // HR Consulting - documents
  7: 'https://images.unsplash.com/photo-1562564055-71e051d33c19', // Government Transactions - signing
  8: 'https://images.unsplash.com/photo-1521791136064-7986c2920216', // Company Establishment - handshake
  9: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40', // Administrative Planning - laptop
  10: 'https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d', // Financial Planning - reports
  11: 'https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20%281%20of%201%29-5.jpg', // Economic Feasibility - meeting
  12: 'https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d', // Financial Feasibility - analysis
  13: 'https://images.unsplash.com/photo-1562564055-71e051d33c19', // Financial Auditing - documents
  14: 'https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d', // Financial Analysis - reports
  15: 'https://images.unsplash.com/photo-1521791136064-7986c2920216' // Commercial Brokerage - handshake
};

const Services = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const serviceTranslations = {
    1: 'management',
    2: 'commercial',
    3: 'strategy',
    4: 'financial',
    5: 'operations',
    6: 'hr',
    7: 'service7',
    8: 'service8',
    9: 'service9',
    10: 'service10',
    11: 'service11',
    12: 'service12',
    13: 'service13',
    14: 'service14',
    15: 'service15'
  };

  return (
    <section id="services" className="services-section">
      <div className="section-header">
        <h2 className="display-large section-title">{t('services.title')}</h2>
        <p className="body-large section-subtitle">
          {t('services.subtitle')}
        </p>
      </div>

      {/* Featured Gulf Images Section */}
      <div className="gulf-images-section">
        <div className="gulf-images-grid">
          <img src={serviceImages[0]} alt="Gulf business consultation" className="gulf-feature-image" />
          <img src={serviceImages[1]} alt="Gulf professionals collaboration" className="gulf-feature-image" />
          <img src={serviceImages[2]} alt="Professional consultation Qatar" className="gulf-feature-image" />
        </div>
      </div>

      <div className="dark-grid">
        {companyInfo.services.map((service) => {
          const IconComponent = iconMap[service.icon];
          const serviceKey = serviceTranslations[service.id];
          return (
            <div key={service.id} className="service-card">
              <div className="service-image-container">
                <img 
                  src={serviceSpecificImages[service.id]} 
                  alt={t(`services.items.${serviceKey}.title`)}
                  className="service-image"
                />
              </div>
              <div className="service-content">
                <div className="service-icon-wrapper">
                  <IconComponent size={32} className="service-icon" />
                </div>
                <h3 className="heading-2 service-title">
                  {t(`services.items.${serviceKey}.title`)}
                </h3>
                <p className="body-medium service-description">
                  {t(`services.items.${serviceKey}.description`)}
                </p>
                <button className="service-learn-more">
                  {t('services.learnMore')}
                  <span className="arrow">→</span>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Services;
